import React from 'react'
import { Menu, MenuItem, Popover, Position } from "@blueprintjs/core";
import {Link, Icon} from './'
import {LoginButton} from './user'
import * as Paths from '../constants/Paths';
import {navigateTo} from 'gatsby-link';
import AppState from '../state/AppState';
import ClassNames from 'classnames';
import {logout} from '../actions/SessionActions'

class DBNavbar extends React.Component {

  constructor(props) {
    super(props);
  }

  render() {

    const { AppState, history, className } = this.props;

    const contClasses = ClassNames("DBNavbar", className);

    const ProfileMenu = (
      <Menu className="">
        <MenuItem text="Settings" iconName="cog" onClick={() => history.push(Paths.DB_USER_SETTINGS)}/>
        <MenuItem text="Logout" iconName="log-out" onClick={() => logout().then(() => history.push(Paths.LOGIN))}/>
      </Menu>
    );
    
    return (
      <div className={contClasses}>
        <Link href={Paths.HOME} className="grid-row v-align logo">
          <Icon name="logo1"/>
          <div className="logo-text">
            SnapTest
          </div>
        </Link>
        {AppState.user && (
          <Link to={Paths.DB_USER_HOME} className="btn-primary">My Accounts</Link>
        )}
        <div className="grid-item login grid-row r-align">
          {AppState.user ? (
            <Popover content={ProfileMenu} position={Position.BOTTOM_RIGHT}>
              <button type="button" className="pt-button pt-minimal">
                {AppState.user.email}
              </button>
            </Popover>
          ) : (
            <LoginButton />
          )}
        </div>
      </div>

    );
  }

}



export default AppState.connect(React, DBNavbar);



// WEBPACK FOOTER //
// ./src/components/DBNavbar.js